/**
 * Convenience function to pad a number to two digits with leading zeros.
 * @param num The number to pad.
 * @returns The padded number as a string.
 */
function padToTwoDigits(num: number): string {
    return num.toString().padStart(2, '0');
}

/**
 * Formats a Unix timestamp into a human-readable UTC date-time string that is
 * suitable for updating and parsing by date-time input fields.
 *
 * @param timestamp - Unix timestamp in seconds (not milliseconds)
 * @returns A formatted string in the format "YYYY-M-D HH:MM:SS UTC"
 *
 * @example
 * ```typescript
 * formatUTC(1704067200); // Returns "2024-1-1 00:00:00 UTC"
 * ```
 */
export function formatUTC(timestamp: number) : string {
    const date = new Date(timestamp * 1000);
    const y = date.getUTCFullYear();
    const mo = padToTwoDigits(date.getUTCMonth() + 1);
    const d = padToTwoDigits(date.getUTCDate());
    const h = padToTwoDigits(date.getUTCHours());
    const mi = padToTwoDigits(date.getUTCMinutes());
    const s = padToTwoDigits(date.getUTCSeconds());
    // return `${d}/${mo}/${y}, ${h}:${mi}:${s}`;
    return `${y}-${mo}-${d} ${h}:${mi}:${s} UTC`;
}

export function convertTimeToExcelTime(date: Date): number {
  // Excel has a bug where it treats 1900 as a leap year, accounting for that
  const excelEpoch = new Date(Date.UTC(1899, 11, 30)); // December 30, 1899
  
  const diffInMs = date.getTime() - excelEpoch.getTime();
  const millisecondsPerDay = 24 * 60 * 60 * 1000;
  
  const excelDateValue = diffInMs / millisecondsPerDay;
  
  return excelDateValue;
}
